import React from 'react';

import 'rc-dialog/assets/index.css';
import './modal.scss';

export const destroyFns: (() => void)[] = [];

export interface ModalFuncProps {
  visible?: boolean;
  title?: string;
  content?: React.ReactNode;
  onOk?: (...args: any[]) => any;
  onCancel?: (...args: any[]) => any;
  afterClose?: () => void;
  children?: any;
}

